// Lib
import React from 'react';
import { useTranslator } from '../../../components/i18n/useTranslator';

/**
 * This component is used when the element does not exist / could not be retrieved for that user.
 */
const NotFoundElementModal = () => {
    const translate = useTranslator('modal', 'element.notFound');

    return (
        <div className="NotFoundElementModal">
            <h2>{translate('title', 'This element could not be found')}</h2>
            <div>
                <p>{translate('message', "Sorry, the element you're trying to view no longer exists.")}</p>
            </div>
        </div>
    );
};

NotFoundElementModal.propTypes = {};

export default NotFoundElementModal;
